import { useCallback } from "react";
import useSearchText from "providers/SearchTextProvider/useSearchText";
import useSetSearchText from "providers/SearchTextProvider/useSetSearchText";
import Search from "components/Inputs/Search";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import type { SearchProps } from "components/Inputs/Search";

interface TablesSearchTextInputProps extends Pick<SearchProps, "placeholder" | "sx" | "slotProps"> {}

function TablesSearchTextInput(props: TablesSearchTextInputProps) {
  const text = useSearchText();
  const setText = useSetSearchText();

  const handleSearchTextChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setText(event.target.value);
    },
    [setText]
  );

  const handleEscapeKeypress: React.KeyboardEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      if (event.key === "Escape") setText("");
    },
    [setText]
  );

  const handleOnClear = useCallback(() => {
    setText("");
  }, [setText]);

  return (
    <ThemeProvider2024>
      <Search
        type="search"
        color="primary"
        onChange={handleSearchTextChange}
        value={text}
        onKeyDown={handleEscapeKeypress}
        fullWidth
        onClear={handleOnClear}
        {...props}
      />
    </ThemeProvider2024>
  );
}

export default TablesSearchTextInput;
